export class Laya3DRender {
}
